export default __webpack_public_path__ + "static/media/thankyou2.cf5658a7.svg";